import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const EnterpriseHeaderLogoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EnterpriseHeaderLogo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"waitOn"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"MemberHeader"}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ofEnterprise"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"EnterpriseHeaderLogo","document":EnterpriseHeaderLogoDocument}} as const;
export type EnterpriseHeaderLogoQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type EnterpriseHeaderLogoQuery = (
  { __typename: 'Query' }
  & { member?: Types.Maybe<(
    { __typename: 'Member' }
    & { ofEnterprise?: Types.Maybe<(
      { __typename: 'OfEnterprise' }
      & Pick<Types.OfEnterprise, 'displayName' | 'source'>
    )> }
  )> }
);




/**
 * __useEnterpriseHeaderLogoQuery__
 *
 * To run a query within a React component, call `useEnterpriseHeaderLogoQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnterpriseHeaderLogoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnterpriseHeaderLogoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnterpriseHeaderLogoQuery(baseOptions: Apollo.QueryHookOptions<EnterpriseHeaderLogoQuery, EnterpriseHeaderLogoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnterpriseHeaderLogoQuery, EnterpriseHeaderLogoQueryVariables>(EnterpriseHeaderLogoDocument, options);
      }
export function useEnterpriseHeaderLogoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnterpriseHeaderLogoQuery, EnterpriseHeaderLogoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnterpriseHeaderLogoQuery, EnterpriseHeaderLogoQueryVariables>(EnterpriseHeaderLogoDocument, options);
        }
export type EnterpriseHeaderLogoQueryHookResult = ReturnType<typeof useEnterpriseHeaderLogoQuery>;
export type EnterpriseHeaderLogoLazyQueryHookResult = ReturnType<typeof useEnterpriseHeaderLogoLazyQuery>;
export type EnterpriseHeaderLogoQueryResult = Apollo.QueryResult<EnterpriseHeaderLogoQuery, EnterpriseHeaderLogoQueryVariables>;